import { Injectable } from '@angular/core';

import { ApiService } from './api.service';
import { CONSTANTS } from '../../constants';

@Injectable({
  providedIn: 'root'
})
export class TradeboardService extends ApiService {

  public addTradeboard(data: any) {
    return this.postOrder(CONSTANTS.API.TRADEBOARD.ADD, data);
  }
  public updateTradeboard(data: any) {
    return this.putOrder(CONSTANTS.API.TRADEBOARD.UPDATE, data);
  }
  public deleteTradeboard(data: any) {
    return this.deleteOrderQueryParams(CONSTANTS.API.TRADEBOARD.DELETE, data);
  }
  public getAllTradeboards() {
    return this.orderGet(CONSTANTS.API.TRADEBOARD.GET);
  }
  public getTradeboardDetails(name: any) {
    return this.orderGet(`${CONSTANTS.API.TRADEBOARD.GET_DETAILS}/${name}`);
  }
}
